"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var total_type_1 = require("../total-type");
var other_type_1 = require("../other-type");
var show_as_type_1 = require("../show-as-type");
/**
 * Base class for category element.
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var CategoryElementDto = /** @class */ (function () {
    function CategoryElementDto() {
        /**
         * Total type
         */
        this.totalType = total_type_1.TotalType.NONE;
        /**
         * When top count used, defines where to show other values(like total)
         */
        this.otherType = other_type_1.OtherType.NONE;
        /**
         * Category show as type
         */
        this.showAsType = show_as_type_1.ShowAsType.NONE;
        this.sortMeasurePathHolderId = null;
        this.topCount = null;
    }
    return CategoryElementDto;
}());
exports.CategoryElementDto = CategoryElementDto;
//# sourceMappingURL=category-element-dto.js.map